/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import { toLeft, toRight } from "ember-animated/transitions/move-over";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import AnxietyFilledJournalEvent from "parog-web/models/anxiety-filled-journal-event";
import type TaskPlannedJournalEvent from "parog-web/models/task-planned-journal-event";
import { sleep } from "parog-web/utils/time";

export default class AnxietyEditionForm extends CrudJournalEventBaseComponent<AnxietyFilledJournalEvent> {
  static forcDisplayName = "Questionnaire d'anxiété";
  static fullComponentId = "anxiety/edition-form";

  static journalEventClass = AnxietyFilledJournalEvent;

  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  duration = 300;

  @tracked currentIndex = 0;

  rules({ oldItems, newItems }) {
    if (oldItems[0] < newItems[0]) {
      return toLeft;
    }
    return toRight;
  }

  get keys() {
    return AnxietyFilledJournalEvent.states;
  }

  get currentKey(): string {
    return this.keys[this.currentIndex];
  }

  @action
  async previousQuestion() {
    await sleep(this.duration / 2);
    this.currentIndex--;
  }

  get currentQuestionKey(): string {
    return this.keys[this.currentIndex];
  }

  @action
  async nextQuestion() {
    await sleep(this.duration / 2);
    this.currentIndex++;
  }

  get isLastQuestion(): boolean {
    return this.currentIndex == this.keys.length - 1;
  }

  @action
  computeLabel(value: number): string | undefined {
    switch (value) {
      case 1:
        return "Presque jamais";
      case 2:
        return "Parfois";
      case 3:
        return "Souvent";
      case 4:
        return "Presque toujours";
      default:
        return undefined;
    }
  }

  @action
  onChange(value: string) {
    this.changeset.set(this.currentKey, value);
    if (!this.isLastQuestion) {
      this.nextQuestion();
    }
  }

  @action
  async save(): Promise<typeof this.journalEventClass> {
    let task: TaskPlannedJournalEvent | null = null;

    if (
      Boolean(this.args.originJournalEventType) &&
      this.args.originJournalEventType == "TaskPlannedJournalEvent" &&
      Boolean(this.args.originJournalEventId)
    ) {
      task = this.store.peekRecord(
        "task-planned-journal-event",
        Number(this.args.originJournalEventId)
      );
      if (task) {
        this.changeset.set("originTaskIdentifier", task.originTaskIdentifier);
      }
    }

    await super.save();

    if (task) {
      await task.processTask("treated");
    }

    if (this.afterCompleted) {
      await this.afterCompleted();
    }
  }
}
